import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { CaretDown, EnvelopeSimple, FileArrowDown, FilePdf, FileXls, Lightning, SquaresFour, Tag } from "@phosphor-icons/react";

export function CartActionsBar({
  itemCount,
  exporting,
  emailingQuote,
  selectedVariantCount,
  onExport,
  onEmailQuote,
  onExportGT,
  onExportGridView,
  onPrintLabels,
  isCustomer = false,
  isSales = false,
  showGTExport = false,
}) {
  const busy = Boolean(exporting) || emailingQuote;
  return (
    <div className="flex flex-wrap items-center gap-2 sm:gap-3">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            size="sm"
            disabled={itemCount === 0 || busy}
            className="rounded-sm bg-blue-600 text-white hover:bg-blue-700"
            data-testid="cart-action-menu-button"
          >
            <Lightning size={14} className={`mr-1.5 ${busy ? "animate-pulse" : ""}`} />
            {busy ? "Working..." : "Action"}
            <CaretDown size={12} className="ml-1.5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="rounded-sm">
          <DropdownMenuItem onClick={() => onExport("pdf")} data-testid="export-pdf-button">
            <FilePdf size={14} className="mr-2" /> Export PDF
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onExport("excel")} data-testid="export-excel-button">
            <FileXls size={14} className="mr-2" /> Export Excel
          </DropdownMenuItem>
          {!isSales && (
            <DropdownMenuItem onClick={onEmailQuote} data-testid="email-quote-button">
              <EnvelopeSimple size={14} className="mr-2" /> Email Quote
            </DropdownMenuItem>
          )}
          <DropdownMenuItem onClick={() => onExport("proforma")} data-testid="export-proforma-button">
            <FilePdf size={14} className="mr-2" /> Print Proforma Invoice
          </DropdownMenuItem>
          {!isSales && (
            <>
              <DropdownMenuItem onClick={onExportGridView} data-testid="export-grid-view-button">
                <SquaresFour size={14} className="mr-2" /> Export to Grid View
              </DropdownMenuItem>
              <DropdownMenuItem onClick={onPrintLabels} data-testid="print-labels-button">
                <Tag size={14} className="mr-2" /> Print Label
              </DropdownMenuItem>
            </>
          )}
          {showGTExport && (
            <DropdownMenuItem
              disabled={selectedVariantCount === 0}
              onClick={onExportGT}
              data-testid="export-gt-offer-sheet-button"
            >
              <FileArrowDown size={14} className="mr-2" />
              Export GT Offer Sheet{selectedVariantCount > 0 ? ` (${selectedVariantCount})` : ""}
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
